'use client';

import { Button } from '@/components/ui/button';
import { siteConfig } from '@/site-config';
import { useCartSummary } from '@veranda/shared/cart/hooks';
import { useCart } from '@veranda/shared/cart/provider';
import { cn, formatMoney } from '@veranda/shared/lib';

export function CartSummary() {
  const { cart, cartTotals, isPending, handleCheckout } = useCartSummary();
  const { loading } = useCart();

  if (!cart) {
    return null;
  }

  const cartTotalDiscounts = cart?.totalDiscounts;

  const formattedCartTotal = formatMoney(cartTotals);
  const formattedCartTotalDiscounts = formatMoney(
    cartTotalDiscounts || { amount: '0', currencyCode: siteConfig.currencyCode }
  );

  return (
    <>
      <div className="flex flex-col gap-2">
        {cartTotalDiscounts && cartTotalDiscounts.amount !== '0' && (
          <CartSummaryItem
            label="Discount"
            value={formattedCartTotalDiscounts}
          />
        )}
        <CartSummaryItem label="Subtotal" value={formattedCartTotal} />
        <span className="text-primary text-sm">
          Shipping and taxes calculated at checkout.
        </span>
      </div>
      <Button
        type="submit"
        isLoading={isPending || loading}
        onClick={handleCheckout}
        className="mt-4 mb-2 w-full"
      >
        Checkout
      </Button>
    </>
  );
}

function CartSummaryItem({
  label,
  value,
  className,
}: {
  label: string;
  value: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-between font-semibold text-primary',
        '!typography-outfit-h4',
        className
      )}
    >
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}
